import React, { useState, useEffect } from 'react';
import Button from './Button';
import './Header.css';

import { NavLink } from 'react-router-dom';
import LangBtn from './LangBtn';

export default function Header({lang, handleLanguageChangeA, handleLanguageChangeB}) {

    const [click, setClick] = useState(false);

    const handleClick = () => setClick(!click);

    useEffect(() => {
         setClick({click : false});
    }, [])


    return (
        
        <header className="flex  items-center lg:pt-4 lg:px-12 xl:pt-6 justify-between xl:px-20 md:px-12 sm:px-8 mx-auto">

            {/* List */}
            <div className={click ? "flex xl:flex items-center  md:text-2xl lg:justify-between  md:justify-between w-full relative menu xl:max-w-[1440px] xl:mx-auto"
                : "flex xl:flex items-center bg-orange lg:justify-between md:text-2xl md:justify-between w-full relative menu open xl:max-w-[1440px] xl:mx-auto"}
            >
                <NavLink to="/">
                    <img src="/assets/icons/tg_logo.svg" alt=""
                        className={click ? "sm:absolute sm:right-10 sm:top-11 md:right-14 md:top-14 logo lg:mb-3"
                            : "sm:absolute sm:right-10 sm:top-11 md:right-14 md:top-14 sm:hidden md:hidden lg:block logo"} />
                </NavLink>
                <div
                    className='xl:hidden lg:hidden text-4xl flex  sm:absolute sm:left-11 sm:top-14 md:left-14 md:top-16 z-30 text-[#ccc]'
                    onClick={handleClick}   >
                    <i className={click ? "fa-solid fa-bars" : "fa-solid fa-xmark"}></i>
                </div>
                <ul className={click ? "flex xl:flex lg:flex justify-evenly w-3/4 lg:text-lg text-lg md:text-[1.5rem] listItems sm:hidden md:hidden lg:pl-24 lg:pr-8"  
                    : "flex xl:flex justify-evenly w-3/4 text-lg md:text-[1.5rem] listItems xl:pl-24 lg:pl-16 lg:pr-8"}>
                    <li><NavLink to="/" className='link link-underline link-underline-black hover:cursor-pointer '>الصفحة الرئيسية</NavLink></li>
                    <li><a href="#whous" className='link link-underline link-underline-black hover:cursor-pointer'>من نحـن</a></li>
                    <li><a href="#services" className='link link-underline link-underline-black hover:cursor-pointer'>ماذا نقـدم</a></li>
                    <li><a href="#paths" className='link link-underline link-underline-black hover:cursor-pointer'>المسـارات</a></li>
                    <li><a href="#works" className='link link-underline link-underline-black hover:cursor-pointer'>أعمالنـا</a></li>
                    <li><a href="#teams" className='link link-underline link-underline-black hover:cursor-pointer'>فريقنـا</a></li>
                </ul>
                <div className={ click ? 'flex justify-evenly items-center p-0 sm:hidden lg:flex lg:items-center lg:justify-center lg:flex-row' : 'flex justify-evenly sm:justify-between items-center p-0 sm:flex-col lg:flex-row' }>
 
                {/* language button */}
                <LangBtn lang={lang} 
                        handleLanguageChangeA={handleLanguageChangeA}
                        handleLanguageChangeB={handleLanguageChangeB}  
                        />
                {/* Join us Button */}
                <Button text="انضم لنـا" click={click} onClick={() => setClick(!click)}/>
                </div>

            </div>
 
        </header>
    )
}


